export default "__VITE_ASSET__Bl4cgA8j__"